import * as React from "react";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import Popin from "../Popin/Popin";
import { quotationFormStyles } from "../QuotationForm/QuotationForm.styles";
import { Customer } from "../../types/Customer";
import QuotationFormCustomer from "../QuotationForm/QuotationFormCustomer";
import { Button, Grid } from "../../../node_modules/@material-ui/core";
import { theme } from "../../theme/theme";

type PopinEditCustomerProps = {
    open: boolean;
    customer: Customer;
    onChange(customer: Customer);
    onCancel();
};

type PopinEditCustomerState = {
    customer: Customer;
};

class PopinEditCustomer extends React.Component<PopinEditCustomerProps & WithStyles<typeof quotationFormStyles>, PopinEditCustomerState> {

    public async componentWillMount() {
        await this.updateState(this.props);
    }

    public async componentWillReceiveProps(nextProps: PopinEditCustomerProps) {
        await this.updateState(nextProps);
    }

    public async updateState(props: PopinEditCustomerProps) {
        this.setState({ customer: props.customer });
    }

    public onChange(customer: Customer) {
        this.setState({
            customer
        });
    }

    public render() {
        const { classes } = this.props;
        return (
            <Popin open={this.props.open} maxWidth="md" title="Modifier un client">
                <QuotationFormCustomer 
                    classes={classes}
                    productName={null}
                    customer={this.state.customer}
                    onChange={this.onChange.bind(this)}
                />
                <Grid container={true} item={true} sm={12} justify="center">
                    <Button 
                        variant="contained" 
                        color="primary" 
                        size="large"
                        onClick={() => this.props.onChange(this.state.customer)}
                    >
                        Valider
                    </Button>
                    <Button 
                        style={{marginLeft: theme.spacing.unit }}
                        type="submit" 
                        variant="outlined" 
                        color="primary" 
                        size="large"
                        onClick={() => this.props.onCancel()}
                    >
                        Annuler
                    </Button>
                </Grid>            
            </Popin>
        );
    }

}

export default withStyles(quotationFormStyles)(PopinEditCustomer);


// WEBPACK FOOTER //
// ./src/components/PopinEditCustomer/PopinEditCustomer.tsx